import { useEffect, useState } from 'react'
import { isValidImageUrl } from '../misc'

export const useIsValidImage = (source: string) => {
  const [isValidImage, setIsValidImage] = useState(false)

  useEffect(() => {
    if (source) {
      isValidImageUrl(source).then(isValid => {
        setIsValidImage(isValid)
      })
    }
  }, [source])

  return isValidImage
}
